import * as React from 'react';
import { useSelector } from 'react-redux';
import camelCaseKeys from 'camelcase-keys';

import { useShopConfig } from 'src/explore/hooks/useShopConfig';
import { IAccountV2 } from 'src/explore/types/shoppe';
import NumberShortener from 'src/explore/services/NumberShortener';

import { AuthButtons } from './elements/AuthButtons';

import styles from './index.module.sass';

interface ILogInProps {
  className?: string;
  isMobile?: boolean;
}

const LogIn: React.FC<ILogInProps> = ({ className, isMobile }) => {
  const config = useShopConfig();
  const account = useSelector<any, IAccountV2>(( state ) =>
    camelCaseKeys( state.data.account.data, { deep: true })
  );

  const accountLink = config.rewardsPointsEnabled ? '/rewards?ref=header' : '/account/orders?ref=header';

  return (
    <>
      {!account ? (
        <AuthButtons className={className} />
      ) : (
        <a className={`login--auth-name ${styles.name} ${className}`} href={accountLink}>
          <div>{`Hi ${account.firstName || 'Food Explorer'}`}</div>
          {account.rewardPoints > 0 && !isMobile && config.rewardsPointsEnabled && (
            <div>
              {`(${NumberShortener.shorten( account.rewardPoints, {
                min: 100,
              })} Reward Points)`}
            </div>
          )}
        </a>
      )}
    </>
  );
};

export default LogIn;
